<script setup>
const config = useRuntimeConfig()
const props = defineProps(
    {
        data: {
            type: Object,
            required: true
        }
    }
)

const error = ref(false)
</script>

<template>

    <!-- Card -->
    <NuxtLink :to="`/${data.locale}/post/${data._id}`">
        <div class="relative">

            <img v-if="!error" class="object-cover object-center w-full h-64 rounded-lg lg:h-48"
                :src="`${config.public.apiBase}/files/serve/${data.featuredImage}?width=400`" alt=""
                @error="error = true">

            <div v-else class="w-full h-64 rounded-lg lg:h-48 flex items-center justify-center  border dark:border-slate-700">
                <svg class="fill-slate-500 dark:fill-slate-400 w-12 h-12">
                    <use xlink:href="#cloud-off-line"></use>
                </svg>
            </div>


            <div
                class="absolute bottom-0 flex m-3 px-4 rounded-full bg-gray-100 dark:bg-gray-800 text-sm text-slate-600 dark:text-slate-300 ">
                {{ $t(data.category) }}
            </div>
        </div>

        <div class="h-12">
            <h1 class="mt-6 text-xl font-semibold text-gray-800 dark:text-white line-clamp-2">
                {{ data.title }}
            </h1>
        </div>

        <div class="w-32 my-6 h-0.5 border-t border-blue-500"></div>

        <p class="text-sm text-gray-500 dark:text-gray-400 line-clamp-3">
            {{ data.excerpt }}
        </p>

    </NuxtLink>
    <!-- End Card -->
</template>